<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template v-if="Origen=='Configuración'" slot="Filtros">
                <div class="col-auto">
                    <label class="col-form-label text-primary">Empresa:</label>
                </div>
                <div class="col-auto">
                    <select @change="GetCmbSucursales()" v-model="Filtro.IdEmpresa" class="form-select form-control-search">
                        <option value="">Todos</option>
                        <option v-for="(item,index) in FiltroEmpresas" :key="index" :value="item.IdEmpresa">{{item.NombreComercial}}</option>
                    </select>
                </div>
                <div class="col-auto">
                    <label class="col-form-label text-primary">Sucursal:</label>
                </div>
                <div class="col-auto">
                    <select @change="Lista()" v-model="Filtro.IdSucursal" class="form-select form-control-search">
                        <option value="">Todos</option>
                        <option v-for="(item,index) in FiltroSucursales" :key="index" :value="item.IdSucursal">{{item.Nombre}}</option>
                    </select>
                </div>
            </template>
			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <!-- <th :class="StyleTh">IdPaqueteSistema</th> -->
                <th :class="StyleTh">Nombre</th>
                <th v-if="Origen=='Configuración'" :class="StyleTh">Empresa</th>
                <th v-if="Origen=='Configuración'" :class="StyleTh">Sucursal</th>
                <th :class="StyleTh">FechaInicio</th>
                <th :class="StyleTh">FechaFin</th>
                <th :class="StyleTh">Estatus</th>
                
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
					<td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                    <td v-if="Origen=='Configuración'"><p :class="StyleTd">{{lista.Empresa_NombreComercial}}</p></td>
                    <td v-if="Origen=='Configuración'"><p :class="StyleTd">{{lista.Sucursal_Nombre}}</p></td>
                    <td><p :class="StyleTd">{{lista.FechaInicio}}</p></td>
                    <td><p :class="StyleTd">{{lista.FechaFin}}</p></td>
                    <td><p :class="StyleTd">{{lista.Estatus}}</p></td>
                    
					<td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="lista.Estatus==='Inactivo'" :pIsModal="true" :pId="lista.IdPaquetexEmpresa" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">
                                <CMoreButtonsL  v-if="lista.Estatus != 'Cancelado' || Origen == 'Sucursal'">
							        <template slot="bodyBtnsL">
                                        <li  v-if="Origen == 'Sucursal'" @click="VerModulos(lista.IdPaquetexEmpresa)">
                                            <a class="dropdown-item">
                                                <i class="far fa-list"></i> Ver Módulos
                                            </a>
                                        </li>
                                        <li  v-if="lista.Estatus!='Activo' && lista.Estatus != 'Cancelado'" @click="ActivarPaquete(lista.IdPaquetexEmpresa)">
                                            <a class="dropdown-item">
                                                <i class="far fa-check"></i> Activar Paquete
                                            </a>
                                        </li>
                                        <li  v-if="lista.Estatus!='Inactivo' && lista.Estatus != 'Cancelado'" @click="CancelarPaquete(lista.IdPaquetexEmpresa)">
                                            <a class="dropdown-item">
                                                <i class="far fa-ban"></i> Cancelar Paquete
                                            </a>
                                        </li>
                                        <li  v-if="lista.Estatus=='Activo'" @click="SuspenderPaquete(lista.IdPaquetexEmpresa)">
                                            <a class="dropdown-item">
                                                <i class="far fa-clock me-1"></i> Suspender Paquete
                                            </a>
                                        </li>
                                    </template>
                                </CMoreButtonsL>
                            </template>
						</CBtnAccion>
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="9"></CSinRegistros>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>
	</div>
</template>

<script>

import moment from 'moment';
import Form from '@/views/modulos/root/paquetessistemaempresa/Form.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionPaqueteSistemaxEmpresa';

export default {
    name: 'ListaPaqueteSistemaxEmpresa',
    props: ['sFiltros','pOrigen','ObjEnviado'],
    components: {Form},
    data() {
        return {
            ConfigList:{
                Title: 'Paquetes Sistema por Empresa',
                IsModal: true,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: '',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar...',
                IdEmpresa:'',
                IdSucursal:'',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Asignar Paquete",
                ModalNameId: 'ModalForm',
                ModalSize: 'lg',
                EmitSeccion: EmitEjecuta,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                ShowBtnSave: true,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            obj: {},
            Origen:'',
            ListaArrayRows: [],               
            FiltroEmpresas:[],
            FiltroSucursales:[],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("paquetesSistemaxEmpresaSucursales",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    IdEmpresa:this.Filtro.IdEmpresa,
                    IdSucursal:this.Filtro.IdSucursal,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                //this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('paquetesSistemaxEmpresa/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            if(this.Origen=='Sucursal'){
                this.$router.push({name:'cuentaSucursal', params:{}});
            } else {
                this.$router.push({name:'panelSubMenus', params:{}});
            }
        },
        VerModulos(Id){
            this.$router.push({name:'modulosPaqueteEmpresa', params:{Id:Id}});
        },
        ActivarPaquete(Id){
            this.$swal(Configs.configActivarPaquete).then((result) =>
            {
                if(result.value)
                {
                    this.$http.post('paquetesSistemaxEmpresaActivar/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configActivarPaqueteConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        CancelarPaquete(Id){
            this.$swal(Configs.configCancelarPaquete).then((result) =>
            {
                if(result.value)
                {
                    this.$http.post('paquetesSistemaxEmpresaCancelar/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configCancelarPaqueteConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        SuspenderPaquete(Id){
            this.$swal(Configs.configSuspenderPaquete).then((result) =>
            {
                if(result.value)
                {
                    this.$http.post('paquetesSistemaxEmpresaSuspender/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configSuspenderPaqueteConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        GetCmbEmpresas(){
			this.$http.get("empresasCuenta",{
                params:{
                    simple: true,
                }
            }).then((res) => {
                this.FiltroEmpresas = res.data.data;             
            }).catch(err => console.error(err))
		},
        GetCmbSucursales(){
			this.FiltroSucursales = [];
			this.Filtro.IdSucursal = '';
            this.$http.get("sucursales",{
                params:{
                    IdEmpresa:this.Filtro.IdEmpresa,
                    simple: 1,
                }
            }).then((res) => {
                this.FiltroSucursales = res.data.data;             
            }).finally(()=>{
                this.Lista();
            }).catch(err => console.error(err))		
		},
        SetConfigVista(){
            if (this.Origen === 'Sucursal'){
                this.ConfigList.TitleFirst = this.obj.Nombre;
                this.Filtro.IdSucursal = this.obj.IdSucursal;
                this.Filtro.IdEmpresa = this.obj.IdEmpresa
                this.ConfigList.BtnNewShow = false;
            } else {
                this.TitleFirst = this.Origen;
                this.obj = {};
            }
        },
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        if(this.ObjEnviado != undefined){
            sessionStorage.setItem('ObjEnviado',JSON.stringify(this.ObjEnviado));
        }

        this.obj = JSON.parse(sessionStorage.getItem('ObjEnviado'));

        this.Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(this.Origen){
            this.ConfigList.TitleFirst = this.Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.SetConfigVista();
        this.GetCmbEmpresas();
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
